import { instance, objectToParams } from '../api';

export const getReportsSellsStock = (args) => instance.get(`/api/v1/reports/sells/stock?${objectToParams(args)}`);

export const getReportsSellsExcel = (args) =>
  instance.get(`/api/v1/reports/sells/excel?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsInvoiced = (args) => instance.get(`/api/v1/reports/invoiced?${objectToParams(args)}`);

export const getReportsDepositsValuation = (args) =>
  instance.get(`/api/v1/reports/deposits/valuation?${objectToParams(args)}`);

export const getReportsSellsDates = (args) => instance.get(`/api/v1/reports/sells/dates?${objectToParams(args)}`);

export const getReportsEfficacy = (args) => instance.get(`/api/v1/reports/efficacy?${objectToParams(args)}`);

export const getReportsEfficacyExcel = (args) =>
  instance.get(`/api/v1/reports/efficacy/excel?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsEfficacySummaryPdf = (args) =>
  instance.get(`/api/v1/reports/efficacy/summary/pdf?${objectToParams(args)}`, { responseType: 'blob' });

export const getReportsEfficacySeriesPdf = (args) =>
  instance.get(`/api/v1/reports/efficacy/series/pdf?${objectToParams(args)}`, { responseType: 'blob' });
